import { useMutation, useQueryClient } from 'react-query';
import { fetchWrapper } from 'utils/fetchWrapper';
import toastr from 'react-hot-toast';
import { generateURL } from 'utilities/hooks/urlGeneration';
import { SPARK_RESOURCE_TYPES } from 'constants/common';
import { ChatPluginFunctionResponse } from './chatPluginFunctionTypes';

type MutationVariables = {
  id?: string;
  pluginID: string;
  pluginFunctionID: string;
  pluginConnectionID?: string;
  pluginFunctionFilterTypeID?: number;
};

/**
 * Hook for adding a chat plugin function
 */
export const useAddChatPluginFunction = (chatID: string) => {
  const queryClient = useQueryClient();

  const addChatPluginFunction = (variables: MutationVariables) => {
    const url = generateURL(SPARK_RESOURCE_TYPES.CHAT_PLUGIN_FUNCTIONS);

    return fetchWrapper<ChatPluginFunctionResponse>({
      url,
      method: 'POST',
      body: {
        data: {
          type: SPARK_RESOURCE_TYPES.CHAT_PLUGIN_FUNCTIONS,
          attributes: {
            chatID,
            pluginFunctionID: variables.pluginFunctionID,
          },
        },
      },
    });
  };

  return useMutation(['addChatPluginFunction', chatID], addChatPluginFunction, {
    onError: (error) => {
      if (error instanceof Error) {
        console.error('Error adding plugin function:', error);
        toastr.error(`Failed to add plugin function: ${error.message}`);
      }
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries([
        SPARK_RESOURCE_TYPES.CHAT_PLUGIN_FUNCTIONS,
        chatID,
      ]);
      toastr.success('Plugin function added successfully');
    },
  });
};
